import React from "react";

import classnames from "classnames";

import { Row, Col } from "Common/Grid";

import makeBem from "Utils/makeBem";

const bem = makeBem("SplitPage");

const SplitPage = ({ children }) => <>{children}</>;

const Wrapper = ({ children, className, ...rest }) => (
  <Row className={classnames(className, bem("row"))} {...rest}>
    {children}
  </Row>
);

const Main = ({ children, className, ...rest }) => (
  <Col xs={12} md={8} className={classnames(className, bem("mainContent"))} {...rest}>
    {children}
  </Col>
);

const Aside = ({ children, className }) => (
  <Col md={4} className={classnames(className, bem("aside"), "max-md:hidden")}>
    {children}
  </Col>
);

SplitPage.Wrapper = Wrapper;
SplitPage.Main = Main;
SplitPage.Aside = Aside;
export default SplitPage;
